import { render, staticRenderFns } from "./HomeDecorationChallenges.vue?vue&type=template&id=80043cde&scoped=true&"
import script from "./HomeDecorationChallenges.vue?vue&type=script&lang=js&"
export * from "./HomeDecorationChallenges.vue?vue&type=script&lang=js&"
import style0 from "./HomeDecorationChallenges.vue?vue&type=style&index=0&id=80043cde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80043cde",
  null
  
)

export default component.exports